import React from 'react';
import {API_BASE_URL, OFFER_TYPES, PAGINATION_DEFAULT_LIMIT} from '../../../helpers/constants';
import {Button} from 'reactstrap';
import ReactTable from 'react-table';
import {I18n} from '../../../I18n/components/promoPage';
import Pagination from '../../Pagination/Pagination';
import './offer-list.css';
import noImg from "../../../assets/images/img-error.svg";

const OfferList = props => {
    const offers = props.offers;
    let firstElementNumber = props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
    const currencies = props.basicOfferPrefs.currencies;
    const paymentModels = props.basicOfferPrefs.paymentModels;
    const tableData = offers.map((offer) => {
        return {
            count_id: firstElementNumber++,
            id: offer.id,
            name: offer.title,
            icon: {
                offerId: offer.id
            },
            redirectCount: offer.redirectCount || 0,
            reward: {
                reward: offer.reward || 0,
                currency: currencies.length ? currencies[offer.currencyId - 1].name : '',
            },
            limit: {
                limit: offer.rewardLimit || 0,
                currency: currencies.length ? currencies[offer.currencyId - 1].name : '',
            },
            paymentModel: paymentModels.length ? paymentModels[offer.paymentModelId - 1].name : '',
            startDate: offer.startDate || 'none',
            endDate: offer.endDate || 'none',
            sOffer: offer.specialOffer || '',
            status: offer.status || '',
            actions: (
                offer.status === OFFER_TYPES.DRAFT ? (
                    <div className="text-center">
                        <Button
                            onClick={() => props.onStartOffer(offer.id)}
                            color="gray-500"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].start}`}
                        >
                            <i className="fa fa-play"/>
                        </Button>
                        <Button
                            onClick={() => props.onEditOffer(offer.id)}
                            className="ml-1"
                            color="inverse"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].edit}`}
                        >
                            <i className="fa fa-edit"/>
                        </Button>
                        <Button
                            onClick={() => {props.isDeleteModalToggle(offer.id)}}
                            className="ml-1"
                            color="danger"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].delete}`}
                        >
                            <i className="fa fa-times"/>
                        </Button>
                    </div>
                ) : offer.status === OFFER_TYPES.ACTIVE ? (
                    <div className="text-center">
                        <Button
                            onClick={() => props.onStopOffer(offer.id)}
                            color="gray-500"
                            size="sm"
                            round="true"
                            icon="true"
                            title={`${I18n[props.lang].stop}`}
                        >
                            <i className="fa fa-stop"/>
                        </Button>
                    </div>
                ) : null
            )
        };
    });
    return (
        <div className="offer-table MyReactTableClass">
            <ReactTable
                getProps={() => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px"
                        }
                    };
                }}
                getTheadProps={() => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={() => {
                    return {
                        style: {
                            borderRight: "none",
                            whiteSpace: "pre-line"
                        }
                    };
                }}
                getTdProps={() => {
                    return {
                        style: {
                            borderRight: "none",
                            textAlign: "center"
                        }
                    };
                }}
                getTrProps={() => {
                    return {
                        style: {
                            alignItems: "center",
                            minHeight: "45px"
                        }
                    };
                }}
                getNoDataProps={() => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: "#",
                        accessor: "count_id",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                        maxWidth: 40
                    },
                    {
                        Header: `${I18n[props.lang].offerList_icon}`,
                        accessor: "icon",
                        sortable: false,
                        filterable: false,
                        style: {
                            textAlign: "center",
                        },
                        width: 60,
                        Cell: row => (
                            <img
                                src={`${API_BASE_URL}/trade/offer/icon/${row.value.offerId}`}
                                alt="offer icon"
                                className="img-fluid media-object"
                                width="40"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noImg
                                }}
                            />
                        )
                    },
                    {
                        Header: `${I18n[props.lang].offerList_name}`,
                        accessor: "name",
                        sortable: true,
                        filterable: false,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        },
                    },
                    {
                        Header: `${I18n[props.lang].offerList_redirectCount}`,
                        accessor: "redirectCount",
                        sortable: false,
                        filterable: false,
                        mixWidth: 100,
                        maxWidth: 140,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase",
                            whiteSpace: "pre-line"
                        }
                    },
                    {
                        Header: `${I18n[props.lang].offerList_reward}`,
                        accessor: "reward",
                        sortable: false,
                        filterable: false,
                        width: 140,
                        style: {
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <span>{`${row.value.reward} ${row.value.currency}`}</span>
                        )
                    },
                    {
                        Header: `${I18n[props.lang].offerList_limit}`,
                        accessor: "limit",
                        sortable: false,
                        filterable: false,
                        width: 140,
                        style: {
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <span>{`${row.value.limit} ${row.value.currency}`}</span>
                        )
                    },
                    {
                        Header: `${I18n[props.lang].offerList_model}`,
                        accessor: "paymentModel",
                        sortable: false,
                        filterable: false,
                        maxWidth: 70,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "uppercase"
                        }
                    },
                    {
                        Header: `${I18n[props.lang].offerList_startDate}`,
                        accessor: "startDate",
                        sortable: false,
                        filterable: false,
                        maxWidth: 110,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                    },
                    {
                        Header: `${I18n[props.lang].offerList_endDate}`,
                        accessor: "endDate",
                        sortable: false,
                        filterable: false,
                        maxWidth: 110,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        },
                    },
                    {
                        Header: `${I18n[props.lang].offerList_offer}`,
                        accessor: "sOffer",
                        sortable: false,
                        filterable: false,
                        width: 140,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase"
                        }
                    },
                    {
                        Header: `${I18n[props.lang].offerList_status}`,
                        accessor: "status",
                        sortable: false,
                        filterable: false,
                        maxWidth: 100,
                        style: {
                            fontSize: "0.8rem",
                            textTransform: "lowercase",
                        },
                        Cell: row => (
                            <span style={{
                                background: row.value === OFFER_TYPES.ACTIVE ? '#22f64a'
                                    : row.value === OFFER_TYPES.DRAFT ? '#8898aa'
                                        : row.value === OFFER_TYPES.CANCELED ? '#f62d51'
                                            : row.value === OFFER_TYPES.FINISHED ? '#3e69f6'
                                                : row.value === OFFER_TYPES.STOPPED ? '#6ca7c1' : '#000000',
                                padding: "3px 5px",
                                borderRadius: "45px",
                                color: "#ffffff"
                            }}>
								{
                                    row.value === OFFER_TYPES.ACTIVE ? `${I18n[props.lang].offerList_active}` :
                                        row.value === OFFER_TYPES.DRAFT ? `${I18n[props.lang].offerList_draft}` :
                                            row.value === OFFER_TYPES.CANCELED ? `${I18n[props.lang].offerList_canceled}` :
                                                row.value === OFFER_TYPES.FINISHED ? `${I18n[props.lang].offerList_finished}` :
                                                    row.value === OFFER_TYPES.STOPPED ? `${I18n[props.lang].offerList_stopped}` : `none`
                                }
							</span>
                        )
                    },
                    {
                        Header: "",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        width: 110
                    }
                ]}
                PaginationComponent={Pagination}
                nextText={">>"}
                previousText={"<<"}
                defaultPageSize={-1}
                pageSize={tableData.length}
                showPaginationBottom={props.totalPages > 1}
                className="-highlight"
                data={tableData}
                filterable
                manual
                onPageChange={props.setCurrentPage}
                page={props.currentPage}
                pages={props.totalPages}
            />
        </div>
    )
};

export default OfferList;



// WEBPACK FOOTER //
// ./src/components/Promo/OfferList/OfferList.js